import { DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { type FC, useEffect } from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { ProgramSelect } from "../../moment/component/program-selector/program-selector";
import type { ProgramsState } from "../../moment/hooks/use-programs";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";

type SurveyAlertWizardStep1Values = Pick<MomentFormMoment, "title" | "program_id">;

type SurveyAlertWizardStep1Props = {
  onCompleteChange: (complete: boolean) => void;
  programs: ProgramsState;
};

export const SurveyAlertWizardStep1: FC<SurveyAlertWizardStep1Props> = ({
  onCompleteChange,
  programs,
}) => {
  const { control } = useFormContext<SurveyAlertWizardStep1Values>();
  const [title, programId] = useWatch({ control, name: ["title", "program_id"] });

  useEffect(() => {
    onCompleteChange(Boolean(title.trim() && programId));
  }, [onCompleteChange, programId, title]);

  return (
    <>
      <DialogTitle>Create a survey response notification?</DialogTitle>
      <DialogContent>
        <Stack spacing={4}>
          <Typography>
            We recommend using our step-by-step Wizard to ensure that your notification is set up
            correctly.
          </Typography>
          <Typography>
            To begin, confirm the name and program for your response notification Communication.
          </Typography>
          <Stack spacing={2}>
            <Controller
              name="title"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  placeholder="Notification name"
                  aria-label="Notification name"
                  fullWidth
                />
              )}
            />
            <Controller
              name="program_id"
              control={control}
              render={({ field }) => (
                <ProgramSelect
                  value={field.value ?? undefined}
                  onChange={field.onChange}
                  programs={programs}
                />
              )}
            />
          </Stack>
        </Stack>
      </DialogContent>
    </>
  );
};
